/* -----------------------------------
Copyright: Logical Developments 2022.
Project:   ConNote Portal
Filename:  ProgressSteps.js
Author:    Dean B. Leggo
Version:   0.11
Description:
Add progress steps within an element for people to navigate to different steps
stepArray -
stepCurrent -
stepControl - function that'll take no arguments and returns true or false if the progressClick can occur.


History:
0.11  01-04-26 MJB   LD0013973 Adjusted stepper component to mirror layout of vendor portal
0.03  09-05-22 DBL   Added new function `control`
0.02  04-05-22 DBL   Added class `clickable` to the steps
0.01  13-03-22 ADM   Updated the Font Awesome imports. Added conditional application of classes to get desired circle colours
0.00	24-02-22 DBL   Created.
----------------------------------- */

import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import useNavigate from './useNavigate';
import './ProgressSteps.css';

function ProgressSteps() {
  const { navType, navState, changeState } = useNavigate();
  if (navType !== 'stepper')
    return new Error(`ProgressSteps can only be used in the 'stepper' Navigate Context. Found ${navType}`);

  const progressClick = (goto) => {
    // block if stepControl retuns false
    if ((navState.hasOwnProperty('control') && navState.stepControl()) || !navState.hasOwnProperty('control')) {
      let newMenu = navState.stepArray.map((item, index) =>
        index + 1 <= goto ? { ...item, click: true } : { ...item, click: false }
      );
      changeState({ ...navState, stepCurrent: goto, stepArray: newMenu });
    }
  };

  return (
    <div className="stepper-layer1">
      <div className="stepper-layer2">
        <div className="stepper-layer3">
          {navState.stepArray.map((value, index) => {
            index += 1;
            const complete = index < navState.stepCurrent;
            const current = index === navState.stepCurrent;
            const upcoming = index > navState.stepCurrent;

            return (
              <div key={value.name} className="stepper-item1">
                <div onClick={value.click ? (() => progressClick(index)) : undefined}
                  className={"stepper-item2 " + (value.click ? 'stepper-item2-clickable' : 'stepper-item2-inactive')}
                >
                  {/* Circle for each stage */}
                  <div className={`stepper-circle 
                    ${complete ? 'stepper-circle-complete' : ''} 
                    ${current ? 'stepper-circle-current' : ''} 
                    ${upcoming ? 'stepper-circle-upcoming' : ''}
                  `}>
                    {/* Icon inside the circle */}
                    {complete && (<FontAwesomeIcon icon={faCheck} className="stepper-icon-complete"/>)}
                    {current && (<FontAwesomeIcon icon={faCircle} className="stepper-icon-current"/>)}
                  </div>
                  
                  {/* Stage text */}
                  <div className="stepper-title">
                    <span className="stepper-title-child">
                      {value.name}
                    </span>
                  </div>
                </div>

                {/* Line between steps */}
                {index < navState.stepArray.length && (
                  <div className="stepper-line"/>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default ProgressSteps;